<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <h6>
                Total projet
                <p class="value">{{ favorite.total_price | number: '1.0-0' }} €</p>
            </h6>
            <i class="fa fa-angle-up"></i>
            <h2>Informations générales</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/info_generale.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview">
            <div class="col-md-12" *ngIf="favorite.ad.ai_id == 0">
                <mat-form-field>
                    <mat-label>Prix affiché</mat-label>
                    <input type="number" step="1000" matInput [(ngModel)]="favorite.init_price"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field>
                    <mat-label>Prix d'achat FAI<i class="fa fa-info-circle"
                                                  matTooltip="Indiquez ici le montant de votre offre d’achat, frais d’agence inclus (FAI)"></i>
                    </mat-label>
                    <input type="number" step="1000" matInput [(ngModel)]="favorite.price"
                           (ngModelChange)="edit($event, 'price')">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field>
                    <mat-label>Frais de notaire<i class="fa fa-info-circle"
                                                  matTooltip="Environ 8% dans l’ancien et 2,5% dans le neuf."></i>
                    </mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.notary_price"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field>
                    <mat-label>Frais d'agence</mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.agency_fees"
                           (ngModelChange)="edit($event)">
                    <span matSuffix>€</span>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field [ngClass]="{'no_plan' : !isLogin}">
                    <mat-label>Typologie du bien</mat-label>
                    <mat-select disableOptionCentering [(ngModel)]="favorite.advice_price_choice" (ngModelChange)="edit($event, 'advice_price_choice')">
                        <mat-optgroup *ngFor="let group of priceChoice | keyvalue: adService.sortGeneralFirst"
                                      [label]="group.key">
                            <mat-option *ngFor="let value of group.value | keyvalue" [value]="value.key">
                                {{ cityService.priceFields[value.key].lib }}
                            </mat-option>
                        </mat-optgroup>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field>
                    <mat-label>Superficie
                        <i class="fa fa-exclamation-triangle" *ngIf="favorite.lots.length > 1"
                           matTooltip="Modifier la surface par lot ci dessous"></i>
                    </mat-label>
                    <input type="number" step="10" matInput [(ngModel)]="favorite.square"
                           (ngModelChange)="edit($event, 'square')"
                           [disabled]="favorite.lots.length > 1">
                    <span matSuffix>m²</span>
                </mat-form-field>
            </div>

            <div class="col-6">
                <mat-form-field>
                    <mat-label>Superficie de terrain</mat-label>
                    <input type="number" step="100" matInput [(ngModel)]="favorite.square_land"
                           (ngModelChange)="edit($event, 'square_land')">
                    <span matSuffix>m²</span>
                </mat-form-field>
            </div>

        </div>
    </div>
</div>
